<template>
    <div class="product-gallery" v-if="product">
        <div class="row m-0">
            <figure class="product-main-image">
                <span class="product-label label-new" v-if="product.new">New</span>
                <span class="product-label label-sale" v-if="product.sale_price">Sale</span>
                <span class="product-label label-top" v-if="product.top">Top</span>
                <span class="product-label label-out" v-if="product.stock === 0">Out Of Stock</span>
                <img
                    id="product-zoom"
                    v-lazy="product[0].images[currentIndex]"
                    alt="product"
                    
                />

                <a
                    href="#"
                    id="btn-product-gallery"
                    class="btn-product-gallery"
                    @click.prevent="openLightBox"
                >
                    <i class="icon-arrows"></i>
                </a>
            </figure>

            <div id="product-zoom-gallery" class="product-image-gallery flex-grow-1">
                <a
                    class="product-gallery-item h-100 h-lg-auto carousel-dot"
                    :class="{active: currentIndex== index}"
                    href="#"
                    v-for="(smPicture, index) in product[0].images"
                    :key="index"
                    @click.prevent="changePicture(index)"
                >
                    <img
                        v-lazy="product[0].images[index]"
                        :width="smPicture.width"
                        :height="smPicture.height"
                        alt="product side image"
                    />
                </a>
            </div>

            <light-box
                ref="lightbox"
                class="light-box"
                :media="lightBoxMedia"
                :show-caption="true"
                :show-light-box="false"
            ></light-box>
        </div>
    </div>
</template>
<script>
import LightBox from 'vue-image-lightbox';
import { VueLazyloadImage } from 'vue-lazyload';
import 'vue-image-lightbox/dist/vue-image-lightbox.min.css';

import { baseUrl } from '~/repositories/repository.js';

export default {
    components: {
        LightBox
    },
    props: {
        product: {
            type: Array,
            default: function() {
                return {
                    sm_pictures: [],
                    pictures: []
                };
            }
        }
    },
    data: function() {
        return {
            baseUrl: baseUrl,
            currentIndex: 0
        };
    },
    computed: {
        lightBoxMedia: function() {
            return this.product[0].images.reduce((acc) => {
                return [
                    ...acc,
                    {
                        thumb: this.product[0].images[this.currentIndex],
                        src: this.product[0].images[this.currentIndex],
                        caption: this.product.name
                    }
                ];
            }, []);
        }
    },
    methods: {
        changePicture: function(index) {
            this.currentIndex = index;
        },
        openLightBox: function() {
            this.$refs.lightbox.showImage(this.currentIndex);
        }
    }
};
</script>